import styled from 'styled-components';
import {SearchIcon, PlusIcon} from '../../atoms/Icons';
import {AnonymousUser} from '../../atoms/Logo';
import FavoriteList from '../../molecules/FavoriteList';
import ActivityHistory from '../../molecules/ActivityHistory';
import ContainedButton from '../../atoms/ContainedButton';
import HelpBox from '../../molecules/HelpBox';
import { ShadowColor,DividerColor,SurfaceColor } from '../../Colors';

const defaulStyle = {
	Wrapper : styled.div`
        padding-left : 3rem;
        padding-right : 3rem;
        background-color : ${SurfaceColor};
        box-shadow: 0px 8px 16px 0px ${ShadowColor};
        border-radius : 5px;
        min-width : 80%;
    `,
	WelcomeUser : styled.div`
        padding : 2rem;
        
        display : flex;
        
        & > div {
            margin-right : 2rem;
        }

        & > h3 {
            border-bottom : 1px solid ${DividerColor};
            padding-bottom : 1rem;
        }
    `,
	UserIcon : styled.img.attrs({
		width : '64px',
		height : '64px',
	})`
            border-radius : 1rem;
    `,
	ActionButtons : styled.div`
        padding : 2rem;
        text-align : right;
        & > button {
            margin-left : 1rem;
            font-size : 2rem;
            padding : 1rem;
            & > span{
                margin-left : 1rem;
            }
        }
    `,
	FavoriteList,
	ActivityHistory,
	ContainedButton,
	PlusIcon,
	SearchIcon,
	AnonymousUser : styled(AnonymousUser)`
        width : 64px;
        height : 64px
    `,
	HelpBox
};

const mobileStyle = {
	Wrapper : styled.div`
        background-color : ${SurfaceColor};
    `,
	ActionButtons : styled.div`
        padding : 2rem;
        text-align : center;
        & > div{
            padding-bottom : 1rem;
            & > button {
                width : 80%;
                margin-left : 1rem;
                font-size : 2rem;
                padding : 1rem;
                & > span{
                    margin-left : 1rem;
                }
            }
        }
    `,
};

export default defaulStyle;
export {mobileStyle};